export default __webpack_public_path__ + "static/media/image4-2.dea1454c.png";